module.exports = __webpack_public_path__ + "img/sixth_cloud.54e0a6c6.png";